<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Card>
            <p slot="title" height="200">
                <Icon type="md-trending-up" size="25" />当前阶梯气价
                <Span v-if="isFlow">（按流量）</Span>
                <Span v-if="!isFlow">（按金额）</Span>
            </p>
            <Span v-if="isMainOverDue && !isStandbyOverDue" style="color: #FF0000;">当前使用备用阶梯</Span>
            <Span v-if="Object.keys(ladderPriceRecent.paras) == 0">当前未设置阶梯气价或者阶梯气价超期</Span>
            <Span v-if="Object.keys(ladderPriceRecent.paras) != 0" v-for="index in [1,2,3,4,5,6]">
                第{{index}}阶梯{{ladderPriceRecent.paras["mainPlanLadder" + index + "Flow"]}}立方米，价格{{ladderPriceRecent.paras["mainPlanLadder" + index + "Price"] / 100}}元/m
                <sup>3</sup>
                <br>
            </Span>
        </Card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSpinShow: false,
                deviceTemp: {},
                isFlow: true,
                rechargeBaseInfo: {},
                ladderPriceRecent: {
                    paras: {}
                },
                isMainOverDue: false,
                isStandbyOverDue: false
            };
        },
        methods: {
            overDue() {
                let that = this;
                if (new Date().getTime() < new Date().getTime(that.ladderPriceRecent.paras.mainPlanStartTime) ||
                    new Date().getTime(that.ladderPriceRecent.paras.mainPlanEndTime) < new Date().getTime()
                ) {
                    that.isMainOverDue = true;
                    if (new Date().getTime() < new Date().getTime(that.ladderPriceRecent.paras.standbyPlanStartTime) ||
                        new Date().getTime(that.ladderPriceRecent.paras.standbyPlanEndTime) < new Date().getTime()
                    ) {
                        that.isStandbyOverDue = true;
                        that.ladderPriceRecent = {
                            paras: {}
                        };
                    } else {
                        that.ladderPriceRecent.paras.mainPlanStartTime = that.ladderPriceRecent.paras.standbyPlanStartTime;
                        that.ladderPriceRecent.paras.mainPlanEndTime = that.ladderPriceRecent.paras.standbyPlanEndTime;
                        that.ladderPriceRecent.paras.mainPlanSettleType = that.ladderPriceRecent.paras.standbyPlanSettleType;
                        that.ladderPriceRecent.paras.mainPlanSettleParameter = that.ladderPriceRecent.paras.standbyPlanSettleParameter;
                        for (let i = 1; i <= 6; i++) {
                            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Flow"] = that.ladderPriceRecent.paras[
                                "standbyPlanLadder" + i + "Flow"];
                            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Price"] = that.ladderPriceRecent.paras[
                                "standbyPlanLadder" + i + "Price"];
                        }
                    }
                }
            },
            getRechargeBaseInfo(param) {
                var that = this;
                that.deviceTemp["meterId"] = param;
                that.isSpinShow = true;
                that.rechargeBaseInfo = {};
                that.ladderPriceRecent = {
                    paras: {}
                };
                //请求设备基础数据
                $.ajax({
                    url: "/api/recharge/getRechargeBaseInfo",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        that.deviceTemp
                    ),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.rechargeBaseInfo = data.body;
                        if (data.body.command) {
                            that.ladderPriceRecent = JSON.parse(data.body.command.commandContent)
                        } else {
                            that.ladderPriceRecent = {
                                paras: {}
                            };
                        }
                        that.overDue();
                        if (data.body.meterTypePayType.indexOf("流量") != -1) {
                            that.isFlow = true;
                            if (!that.isStandbyOverDue && data.body.command) {
                                var recordRecent = {};
                                recordRecent["recordRechargeMeterId"] = that.rechargeBaseInfo.meterId;
                                console.log(that.ladderPriceRecent.paras);
                                if (that.ladderPriceRecent.paras.mainPlanSettleType == 0 ||
                                    that.ladderPriceRecent.paras.mainPlanSettleType == 4) {
                                    recordRecent["recordRechargeDateMin"] = new Date(that.ladderPriceRecent
                                        .paras.mainPlanStartTime).getTime();
                                } else {
                                    let days = 0;
                                    if (that.ladderPriceRecent.paras.mainPlanSettleType == 1) {
                                        days = 30;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 2) {
                                        days = 90;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 3) {
                                        days = 365;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 5) {
                                        days = that.ladderPriceRecent.paras.mainPlanSettleParameter;
                                    }
                                    let count = (new Date().getTime() - new Date().getTime(that.ladderPriceRecent
                                        .paras.mainPlanStartTime)) / (days * 24 * 60 * 60 * 1000);
                                    count = count >> 0;
                                    recordRecent["recordRechargeDateMin"] = new Date(that.ladderPriceRecent
                                        .paras.mainPlanStartTime).getTime() + count * (days * 24 * 60 *
                                        60 * 1000);
                                }
                                if (data.body.command.commandTimestamp > recordRecent[
                                        "recordRechargeDateMin"]) {
                                    recordRecent["recordRechargeDateMin"] = data.body.command.commandTimestamp;
                                }
                            }
                        } else if (data.body.meterTypePayType.indexOf("金额") != -1) {
                            that.isFlow = false;
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            }
        }
    };
</script>

<style>
</style>
